<script lang="ts">
  import Checkbox from '$shared/atoms/Checkbox/Checkbox.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    disabled?: boolean;
    checked?: boolean;
    name?: string;
    disclaimers?: string[];
    suffixLabel?: string;
    onchange?: (e: Event) => void;
  }

  let {
    disabled = false,
    checked = false,
    name = '',
    disclaimers = [],
    suffixLabel = '',
    onchange
  }: Props = $props();
</script>

<div class="comp-verify-checkbox">
  <div class="checkbox">
    <Checkbox name={`${name}-verify`} {disabled} {checked} {onchange}>
      <div class="checkbox-label">
        Verify this record {#if suffixLabel}
          <b>{suffixLabel}</b>
        {/if}
      </div>
    </Checkbox>
  </div>
  <div class="disclaimers">
    {#each disclaimers as disclaimer}
      <div data-cy="disclaimer" class="disclaimer">
        <div class="icon"><Icon size="12px" value="icon-alert-triangle" /></div>
        <div data-cy="disclaimer-text" class="text">{disclaimer}</div>
      </div>
    {/each}
  </div>
</div>

<style>
  .comp-verify-checkbox {
    background-color: var(--grey-bg);
    padding: 16px;
  }
  .disclaimer {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-medium);
    margin-top: 16px;
    margin-left: 24px;
  }
  .disclaimer .icon {
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
</style>
